<div class="ds-menu-item-wrapper text-md-center"
     [id]="'navbar-section-' + section.id">
  <ng-container *ngComponentOutlet="(sectionMap$ | async).get(section.id).component; injector: (sectionMap$ | async).get(section.id).injector;"></ng-container>
</div>
